module.exports = __webpack_public_path__ + "img/progress-mockups.75c735fa.webp";